import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ContractConfirmationEffects } from './+state/contract-confirmation.effects';
import { contractConfirmationFeature } from './+state/contract-confirmation.reducer';

export const provideContractConfirmationFeature = () => {
  return makeEnvironmentProviders([provideState(contractConfirmationFeature), provideEffects(ContractConfirmationEffects)]);
};
